'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = polyfillCheck;

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// check for some polyfills and throw a console.error if they don't exist
function polyfillCheck() {
  var root = window || global;
  var canCheck = (typeof IS_STANDALONE === 'undefined' || typeof IS_STANDALONE === 'boolean' && IS_STANDALONE !== true) && root && root.hubspot;

  if (!canCheck) {
    return;
  }

  // checks for the symbol polyfill added by HeadJS
  // the structure was inspired by CoreJS window.core object
  var hasPolyfills = root.hubspot.polyfills !== null && _typeof(root.hubspot.polyfills) === 'object' && root.hubspot.polyfills.Symbol === true;

  var isDeployed = _enviro2.default.deployed('hub-http');
  if (!isDeployed && !hasPolyfills) {
    var message = 'Couldn\'t find HeadJS polyfills. Please include either the standard-head-with-polyfills.js bundle or polyfills/core.js from HeadJS\'.\n\nMore information: https://product.hubteam.com/docs/frontend/docs/polyfills.html';
    // eslint-disable-next-line no-console
    console.error(message);
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.193/js/polyfillCheck.js
// module id = 456
// module chunks = 3 4 5